import Text from 'components/_UI/Text'
import React from 'react'
import { Edit, Trash2 } from 'react-feather'
import styled from 'styled-components'
import { Row } from 'styled/alignment/Row'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'
import fonts from 'theme/fonts'

const platformLabels = {
    meta: 'Meta (Facebook)',
    google: 'Google',
    tiktok: 'TikTok',
}

const platformColors = {
    meta: '#1877F2',
    google: '#4285F4',
    tiktok: '#000000',
}

const eventLabels = {
    AddToCart: 'Adicionar ao Carrinho',
    InitiateCheckout: 'Iniciar Pagamento',
    AddPaymentInfo: 'Info de pagamento',
    Lead: 'Lead',
    Purchase: 'Compra',
}

export default function PixelCard({ data, onEdit, onDelete }) {
    return (
        <CardContainer>
            <CardDetails>
                <Row verticalCenter style={{ gap: '8px', marginTop: 0 }}>
                    <PlatformDot color={platformColors[data?.platform]} />
                    <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                        {platformLabels[data?.platform] || data?.platform}
                    </Text>
                </Row>

                <Text name='small' color={colors.night} marginTop='6px'>
                    <b>Pixel ID:</b> {data?.pixel_id}
                </Text>

                <Row verticalCenter style={{ marginTop: '4px', gap: '4px' }}>
                    <Text name='small' color={colors.night} paddingBottom={0}>
                        <b>Status:</b>
                    </Text>
                    <Status active={data?.is_active}>
                        {data?.is_active ? 'Ativo' : 'Desativado'}
                    </Status>
                </Row>

                {data?.tracking_events?.length > 0 && (
                    <EventTags>
                        {data.tracking_events.map(key => (
                            <EventTag key={key}>
                                {eventLabels[key] || key}
                            </EventTag>
                        ))}
                    </EventTags>
                )}
            </CardDetails>

            <IconsContainer>
                <Edit
                    size={14}
                    color={colors.primaryLight}
                    onClick={onEdit}
                    style={{ cursor: 'pointer' }}
                />
                <Trash2
                    size={14}
                    color={colors.danger}
                    onClick={onDelete}
                    style={{ cursor: 'pointer' }}
                />
            </IconsContainer>
        </CardContainer>
    )
}

const CardContainer = styled.div`
    background-color: ${colors.neutralLight};
    box-shadow: 0 2px 7px #ddd;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 31.5%;
    }
`

const CardDetails = styled.div`
    display: flex;
    flex-direction: column;
`

const PlatformDot = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ color }) => color || colors.night};
`

const Status = styled.div`
    padding: 2px 6px;
    border-radius: 4px;
    color: ${colors.neutral};
    font-size: ${fonts.sizes.mini};
    font-weight: bold;
    text-align: center;

    ${({ active }) => active ? `
        background: ${colors.success};
    ` : `
        background: ${colors.nightLight};
    `}
`

const EventTags = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 6px;
`

const EventTag = styled.span`
    padding: 2px 6px;
    border-radius: 4px;
    background: ${colors.primaryLight};
    color: ${colors.neutral};
    font-size: ${fonts.sizes.mini};
    white-space: nowrap;
`

const IconsContainer = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    gap: 10px;

    svg {
        transition: transform 0.2s;
        &:hover {
            transform: scale(1.05);
        }
    }
`
